export { default as logger } from "./util/logger.js";

export { Barrels } from "./service/barrels.service.js";

export type { BarrelConfiguration } from "./model/barrel-configuration.interface.js";
export type { GenericOptions } from "./model/generic-options.interface.js";
export type { ConfigurationInterface as Configuration } from "./model/configuration.interface.js";

export { Target } from "./enum/target.enum.js";
export { Location } from "./enum/location.enum.js";
